import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { Globe, ChevronDown } from "lucide-react";
import { SUPPORTED_LANGS, LANG_LABELS } from "../i18n";
import { langFromPath, localizePath } from "../lib/locale";

// Selettore lingua IT / EN / DE. Mantiene la pagina corrente cambiando prefisso.
export default function LangSwitcher({ variant = "desktop" }) {
  const location = useLocation();
  const current = langFromPath(location.pathname);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const change = (lang) => {
    setOpen(false);
    try {
      localStorage.setItem("torri_lang", lang);
    } catch (e) {
      /* noop */
    }
    // Full reload: il content layer viene ricostruito nella lingua scelta.
    window.location.assign(localizePath(location.pathname, lang));
  };

  if (variant === "mobile") {
    return (
      <div className="mt-8 flex items-center gap-2" data-testid="lang-switcher-mobile">
        {SUPPORTED_LANGS.map((l) => (
          <button
            key={l}
            onClick={() => change(l)}
            data-testid={`lang-option-mobile-${l}`}
            className={`px-4 py-2 text-sm uppercase tracking-[0.14em] border transition-colors ${
              current === l
                ? "text-black border-transparent"
                : "text-white/70 border-white/20 hover:text-white hover:border-white/40"
            }`}
            style={current === l ? { background: "#F9E212" } : {}}
          >
            {LANG_LABELS[l]}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div ref={ref} className="relative" data-testid="lang-switcher">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid="lang-switcher-trigger"
        aria-label="Cambia lingua"
        className="flex items-center gap-1.5 text-white/80 hover:text-white text-[12px] uppercase tracking-[0.12em] transition-colors"
        style={{ fontFamily: "Space Grotesk, sans-serif" }}
      >
        <Globe size={15} />
        <span>{LANG_LABELS[current]}</span>
        <ChevronDown size={13} className={`transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-3 min-w-[120px] bg-black/95 backdrop-blur-md border border-white/10 py-1.5 z-50">
          {SUPPORTED_LANGS.map((l) => (
            <button
              key={l}
              onClick={() => change(l)}
              data-testid={`lang-option-${l}`}
              className={`block w-full text-left px-4 py-2 text-[12px] uppercase tracking-[0.12em] transition-colors ${
                current === l ? "text-[#F9E212]" : "text-white/70 hover:text-white hover:bg-white/[0.06]"
              }`}
              style={{ fontFamily: "Space Grotesk, sans-serif" }}
            >
              {LANG_LABELS[l]}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
